import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DotMenu, { Options } from '../primitives/dotMenu/DotMenu';
import { MenuConstants } from '../../constants/MenuConstants';
import ActionDropdown from '../primitives/dropdowns/ActionDropdown';

interface ConfigMenuProps {
  className?: string;
  iconSize?: string;
  dropdownMenu?: boolean;
  onOptionClick?: Function;
}

const CategoryKeyMenu: React.FC<ConfigMenuProps> = ({
  iconSize = '',
  className = '',
  dropdownMenu = false,
  onOptionClick
}) => {
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState<Options | null>();
  const { t } = useTranslation();

  useEffect(() => {
    if (selectedOption) {
      switch (selectedOption.key) {
        case MenuConstants.CONFIG_KEY_CREATE_CATEGORY:
          navigate('/config-category/create');
          break;
        case MenuConstants.CONFIG_KEY_ASSIGN_TO_ORG:
          if (onOptionClick) {
            setSelectedOption(null);
            onOptionClick(MenuConstants.CONFIG_KEY_ASSIGN_TO_ORG);
          }
          break;
      }
    }
  }, [selectedOption]);

  const actionDropDownOptions: Array<any> = [
    {
      display: `${t('T_CATEGORY_NEW')}`,
      key: MenuConstants.CONFIG_KEY_CREATE_CATEGORY
    },
    {
      display: `${t('T_ASSIGN_TO_CATEGORY')}`,
      key: MenuConstants.CONFIG_KEY_ASSIGN_TO_ORG
    }
  ];

  return (
    <>
      <ActionDropdown
        options={actionDropDownOptions}
        onSelectedOptionChange={(value: any) => {
          setSelectedOption(value);
        }}
        value={selectedOption}
        defaultLabel={t('T_CATEGORY_KEYS')}
      />
    </>
  );
};

export default CategoryKeyMenu;
